import formatNumWithCommas from './formatNumWithCommas.js';

/**
 *
 * @param {number} dist in FEET
 * @return {string} dist rounded, in feet or miles, with commas between thousands
 *
 */
export default function (dist) {

  /*
  // Private function
  function formatNumWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  */

  if (dist < 1) return '';
  if (dist < 5280) return formatNumWithCommas(Math.round(dist)) + ' feet ';
  if (dist > 5280) return formatNumWithCommas((dist / 5280).toFixed(1)) + ' miles ';
}
